import './App.css';
import React, { Component } from 'react';
import createStore from './store/configureStore';
import createHistory from 'history/createBrowserHistory';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { Router } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';

import AppWrapper from './AppWrapper';
import Blog from './components/Blog';
import Blogs from './components/Blogs';
import Footer from './components/nav/Footer';
import Header from './components/nav/Header';
import Home from './components/Home';
import Project from './components/Project';
import Projects from './components/Projects';
import withTracker from './components/common/withTracker';

const history = createHistory({});
const { persistor, store } = createStore();

class App extends Component {
  render() {
    return (
      <div className="App container-fluid">
        <Provider store={store} history={history}>
          <PersistGate loading={null} persistor={persistor}>
            <AppWrapper>
              <Router history={history}>
                <React.Fragment>
                  <Header />
                  <Switch>
                    <Route exact path="/projects" component={withTracker(Projects)} />
                    <Route exact path="/project/:projectId/:urlTitle?" component={withTracker(Project)} />
                    <Route exact path="/blogs/:id/:shortURL" component={withTracker(Blog)} />
                    <Route exact path="/blogs" component={withTracker(Blogs)} />
                    <Route path="/" component={withTracker(Home)} />
                  </Switch>
                  <Footer />
                </React.Fragment>
              </Router>
            </AppWrapper>
          </PersistGate>
        </Provider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js